import { Injectable      } from '@angular/core';
import { NotifierManager } from '../managers/notifier/notifier.manager';
import { Notifier        } from '../enums/notifier/notifier.enum';
import { NotifierMessage } from '../enums/notifier/message/notifier.enum';

@Injectable
({
  providedIn: 'root'
})

export class CounterService 
{
    constructor(private _notifier : NotifierManager) {}

    lGeneric()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.COUNTER_SERVICE_L_GENERIC)
    }

    lNotAuth()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.COUNTER_SERVICE_L_NOT_AUTH)
    }

    setGeneric()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.COUNTER_SERVICE_SET_GENERIC)
    }

    setNotAuth()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.COUNTER_SERVICE_SET_NOT_AUTH)
    }

    unsetGeneric()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.COUNTER_SERVICE_UNSET_GENERIC)
    }

    unsetNotAuth()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.COUNTER_SERVICE_UNSET_NOT_AUTH)
    }
}